export const Data_Section = 'Register_Section'
export const Account_Section = 'Account_Section'
export const ServiceFees_Section = 'ServiceFees'
export const Network_section = 'Network_section'
export const Adminaddress= "Admin_address"
export const createprofile = "Createprofile"
export const Follow = "Follow"
